const Hire = () => {
    return (
        <>
        <div className='content' id='Hire'>
            <h2><b>Hire Me!</b></h2>
            <p>I am currently looking for a junior or entry level position as a software developer. If you like what you see in this portfolio and would like you hire me   <a href='https://www.linkedin.com/in/owen-m-9b451314/'>you can contact me via my LinkedIn here.</a></p>
            <p>If you're interested in seeing more of my work, <a href='https://github.com/OwenPortfolio'>you can visit my Github account here</a>, or even <a href='https://www.codewars.com/users/OwenInTraining'>take a look at my codewars profile.</a>.</p>
            
        </div>
        </>
    )
}

export default Hire;